import { apiService } from './api/api';
import { API_ENDPOINTS } from '../constants/api';
import { PagedReservationResponseDto, ReservationResponseDto } from '../types/reservation';

class ReservationAdminService {
  async getReservations(page = 1, limit = 10, status?: string): Promise<PagedReservationResponseDto> {
    const params: Record<string, string> = { page: String(page), limit: String(limit) };
    if (status) params.status = status;
    const query = new URLSearchParams(params).toString();
    return await apiService.get<PagedReservationResponseDto>(`${API_ENDPOINTS.ADMIN.RESERVATIONS.GET}?${query}`);
  }

  async confirmReservation(id: string): Promise<ReservationResponseDto> {
    return await apiService.patch<ReservationResponseDto>(API_ENDPOINTS.ADMIN.RESERVATIONS.CONFIRM.replace(':id', id));
  }

  async cancelReservation(id: string, reason?: string): Promise<ReservationResponseDto> {
    const payload = reason ? { reason } : undefined;
    return await apiService.patch<ReservationResponseDto>(API_ENDPOINTS.ADMIN.RESERVATIONS.CANCEL.replace(':id', id), payload);
  }

  async startPreparation(id: string): Promise<ReservationResponseDto> {
    return await apiService.patch<ReservationResponseDto>(API_ENDPOINTS.ADMIN.RESERVATIONS.START_PREPARATION.replace(':id', id));
  }

  async markDelivered(id: string): Promise<ReservationResponseDto> {
    return await apiService.patch<ReservationResponseDto>(API_ENDPOINTS.ADMIN.RESERVATIONS.MARK_DELIVERED.replace(':id', id));
  }

  async markActive(id: string): Promise<ReservationResponseDto> {
    return await apiService.patch<ReservationResponseDto>(API_ENDPOINTS.ADMIN.RESERVATIONS.MARK_ACTIVED.replace(':id', id));
  }

  async markPendingReturn(id: string): Promise<ReservationResponseDto> {
    return await apiService.patch<ReservationResponseDto>(API_ENDPOINTS.ADMIN.RESERVATIONS.MARK_PENDING_RETURN.replace(':id', id));
  }

  async markInReturn(id: string): Promise<ReservationResponseDto> {
    return await apiService.patch<ReservationResponseDto>(API_ENDPOINTS.ADMIN.RESERVATIONS.MARK_IN_RETURN.replace(':id', id));
  }

  async markReturned(id: string): Promise<ReservationResponseDto> {
    return await apiService.patch<ReservationResponseDto>(API_ENDPOINTS.ADMIN.RESERVATIONS.MARK_RETURNED.replace(':id', id));
  }

  async completeReservation(id: string): Promise<ReservationResponseDto> {
    return await apiService.patch<ReservationResponseDto>(API_ENDPOINTS.ADMIN.RESERVATIONS.COMPLETE.replace(':id', id));
  }
}

export const reservationAdminService = new ReservationAdminService();
